<template>
  <b-row class="d-flex justify-content-end">
    <b-col
      md="4"
      class="my-1"
    >
      <b-input-group size="sm">
        <b-form-select
          id="sortBySelect"
          v-model="sortBy"
          :options="sortOptions"
          class="w-75"
        >
          <template v-slot:first>
            <option value="">
              -- Sort --
            </option>
          </template>
        </b-form-select>
        <b-form-select
          v-model="sortDesc"
          size="sm"
          :disabled="!sortBy"
          class="w-25"
        >
          <option :value="false">
            Asc
          </option>
          <option :value="true">
            Desc
          </option>
        </b-form-select>
      </b-input-group>
    </b-col>
    <b-col
      md="4"
      class="my-1"
    >
      <b-input-group size="sm">
        <b-form-input
          id="filterInput"
          v-model="filter"
          type="search"
          placeholder="Type to Search"
        />
        <b-input-group-append>
          <b-button
            :disabled="!filter"
            @click="filter = ''"
          >
            Clear
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-col>

    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        show-empty
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
      >
        <template #empty>
          <TableDataFetching
            :rows="items"
            :data-loading="dataLoading"
          />
        </template>
        <template #cell(name)="data">
          <div class="d-flex align-items-start">
            <div>
              <div class="ml-2">
                {{ data.value }}
              </div>
            </div>
          </div>
        </template>
        <template #cell(is_active)="data">
          <b-badge :variant="`light-${data.value ? 'success': 'danger'}`">
            {{ data.value ? 'Active': 'Inactive' }}
          </b-badge>
        </template>
        <!--        Edit Action-->
        <template #cell(Action)="data">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="btn-icon rounded-circle"
            @click="statusAction(data.item)"
          >
            <feather-icon icon="Edit3Icon" />
          </b-button>
        </template>
      </b-table>

      <b-modal
        id="report-modal-set-notification"
        ref="modal"
        size="ov-custom"
        hide-footer
        title="Report Notifications"
      >
        <b-overlay
          :show="modalLoading"
          blur="10px"
          opacity="0.30"
          rounded="sm"
          variant="light"
        >
          <b-form @submit.prevent="handleSubmit()">
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Name"
                >
                  <b-form-input
                    v-model="form.name"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col md="6" />
              <b-col md="6">
                <b-form-group
                  label="Send To Role:"
                >
                  <v-select
                    v-model="form.user_roles['staff-api']"
                    :options="roleoptions"
                    :reduce="option => option.id"
                    label="name"
                    multiple
                    placeholder="Select Role"
                  >
                    <template v-slot:option="option">
                      {{ option.name }}
                    </template>
                    <template #search="{attributes, events}">
                      <input
                        class="vs__search"
                        style="pointer-events:none"
                        v-bind="attributes"
                        v-on="events"
                      >
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Send To Email:"
                >
                  <b-form-input
                    v-model="form.email"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <!--              email subject-->
                <b-form-group
                  label="Email Subject"
                >
                  <b-form-input
                    id="subject"
                    v-model="form.subject"
                    placeholder="Enter subject"
                    class="mb-1"
                    :required="form.is_active"
                    @focus="handleOnFocus"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6" />
              <b-col cols="12">
                <b-form-group
                  label="Email Body"
                >
                  <b-form-textarea
                    id="email_body"
                    ref="email_content"
                    v-model="form.email_body"
                    placeholder="Write Email Content"
                    rows="3"
                    :state="form.email_body.length <= emailBodyMaxChar"
                    class="char-textarea"
                    :class="form.email_body.length >= emailBodyMaxChar ? 'text-danger' : ''"
                    :maxlength="emailBodyMaxChar"
                    no-resize
                    :required="form.is_active"
                    @focus="handleOnFocus"
                  />
                  <small
                    class="textarea-counter-value float-right"
                    :class="form.email_body.length >= emailBodyMaxChar ? 'bg-danger' : ''"
                  >
                    <span class="char-count">{{ form.email_body.length }}</span> / {{ emailBodyMaxChar }}
                  </small>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Send At (Time):"
                >
                  <b-form-timepicker
                    v-model="form.job_execution_time"
                    show-seconds
                    :hour12="false"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="12"
                style="margin-top:5px;"
              >
                <b-form-group
                  label="Status"
                >
                  <b-form-checkbox
                    v-model="form.is_active"
                    :value="true"
                    class="custom-control-secondary"
                  >
                    Active
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="4" />

              <!-- submit and reset -->
              <b-col class="d-flex justify-content-end">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                >
                  Submit
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="outline-secondary"
                  @click="clearForm()"
                >
                  Reset
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-overlay>
      </b-modal>

    </b-col>
  </b-row>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BForm,
  BBadge,
  BFormTextarea,
  BFormCheckbox,
  BOverlay,
  BFormTimepicker,
} from 'bootstrap-vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import StatusNotificationTable from '@/components/Notification/StatusNotificationTable.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const NotificationSettingRepository = RepositoryFactory.get('notificationSetting')
const RoleRepository = RepositoryFactory.get('role')
export default {
  components: {
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BForm,
    BBadge,
    BFormTextarea,
    BOverlay,
    BFormCheckbox,
    BFormTimepicker,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      maxChar: 120,
      emailBodyMaxChar: 600,
      roleoptions: [],
      tagOptions: StatusNotificationTable.data().tagOptions,
      // datatable
      sortBy: '',
      sortDesc: false,
      modalLoading: false,
      dataLoading: true,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'is_active', label: 'Active Email', sortable: false },
        { key: 'Action', label: 'Action', sortable: false },
      ],
      items: [],
      form: {
        name: '',
        is_active: false,
        email_body: '',
        subject: '',
        user_roles: [],
        email: '',
        job_execution_time: '',
      },
      selectedTextfieldId: '',
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchDataForReminderNotification()
      },
    },
  },
  mounted() {
    this.fetchDataForReportNotification()
    this.readDataforRole()
  },
  methods: {
    async fetchDataForReportNotification() {
      try {
        const { data } = (await NotificationSettingRepository.getReportNotificationResource())
        this.items = data.data
        this.items.forEach(element => {
          // eslint-disable-next-line no-param-reassign
          element.user_roles = {
            'staff-api': element.role_id ? JSON.parse(element.role_id) : [],
            'merchant-api': [],
          }
        })
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async readDataforRole() {
      try {
        const { data } = (await RoleRepository.getRoleListDropdown()).data
        this.roleoptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async handleSubmit() {
      try {
        this.modalLoading = true
        const payload = {
          name: this.form.name,
          is_active: this.form.is_active,
          email_body: this.form.email_body,
          email: this.form.email,
          job_execution_time: this.form.job_execution_time,
          role_id: this.form.user_roles['staff-api'] || [],
          subject: this.form.subject,
        }
        const res = (await NotificationSettingRepository.updateReportNotificationResource(this.form.id, payload))
        if (res.status === 200) {
          this.showSuccessMessage('Data Updated Successfully')
          this.$bvModal.hide('report-modal-set-notification')
          this.fetchDataForReportNotification()
        } else {
          this.showErrorMessage('Data Update Failed')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
    handleOnFocus(e) {
      this.selectedTextfieldId = e.target.id
    },
    statusAction(form) {
      this.form = { ...form }
      this.form.name = form.name || ''
      this.form.is_active = form.is_active || false
      this.form.email_body = this.form.email_body || ''
      this.form.email = this.form.email || ''
      this.form.job_execution_time = this.form.job_execution_time || ''
      this.form.subject = this.form.subject || ''
      this.form.user_roles = form.user_roles || { 'staff-api': [] }
      this.$bvModal.show('report-modal-set-notification')
    },
    clearForm() {
      this.form.user_roles = { 'staff-api': [], 'merchant-api': [] }
      this.form.is_active = false
      this.form.email_body = ''
      this.form.subject = ''
      this.form.user_roles = []
      this.form.email = ''
      this.form.job_execution_time = ''
    },
  },
}
</script>
